<template>
  <p class="stacked-y-axis">
    {{ label }}
  </p>
</template>

<script>
export default {
  name: "StackedAxisInfo",
  props: ["label"],
};
</script>

<style lang="scss" scoped>
.stacked-y-axis {
  position: absolute;
  top: toRem(15);
  left: toRem(57);
  transform: translate(0, -50%);
  display: flex;
  align-items: center;
  color: white;
  @include dida-S;
}
</style>
